import { useEffect, useMemo } from "react";
import { IItemProps } from "devextreme-react/form";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";

import { getUserProfileFromCache } from "../../services/userSettingService";

import { InactivatableCrudDataGrid } from "../common/InactivatableCrudDataGrid";

import { dummyMappingRuleTypeSettingRow, mappingRuleTypeSettingColumns } from "./model/metaData";
import { MappingRuleTypeSettingDimensionOptions } from "./MappingRuleTypeSettingDimensionOptions";

const ruleTypeDataSource = [
  { value: 1, text: "Journal Entry Type Mappings" },
  { value: 2, text: "Affix Mappings" },
  { value: 3, text: "Accounting Date Mappings" },
  { value: 4, text: "Reference Field Mappings" },
  { value: 5, text: "Group Mappings" },
  { value: 100, text: "Journal Entry Export Settings" },
];

const MappingRuleTypeSettings = (pageProps: PageProps) => {
  const logger = pageProps.loggerProvider.getLogger("MappingRuleTypeSettings");
  logger.debug("Rendering MappingRuleTypeSettings page");

  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  const editorItemOptions = useMemo(() => new Map<string, IItemProps>([
    [
      "ruleType",
      {
        editorType: "dxSelectBox",
        editorOptions: {
          dataSource: ruleTypeDataSource,
          valueExpr: "value",
          displayExpr: "text",
        },
      },
    ],
    [
      "active",
      {
        editorType: "dxCheckBox",
      },
    ],
  ]), []);

  const organizationId = getUserProfileFromCache(pageProps.dataStore).defaultOrganization;
  const detailComponent = (props: any) => {
    return (
      <MappingRuleTypeSettingDimensionOptions
        parentKey={{
          organizationId: organizationId,
          ruleType: props.data.data.ruleType.toString(),
        }}
        pageProps={pageProps}
        logger={logger}
      />
    );
  };

  return (
    <InactivatableCrudDataGrid
      pageProps={pageProps}
      logger={logger}
      dummyRow={dummyMappingRuleTypeSettingRow}
      baseUrl="mapping-rule-type-settings"
      isOrganizationData={true}
      keyExpr="ruleType"
      formTitle="Mapping Rule Type Setting"
      formColCount={2}
      formColSpan={2}
      allowAdding={true}
      allowUpdating={true}
      allowDeleting={true}
      columnConfigs={mappingRuleTypeSettingColumns}
      masterDetailComponent={detailComponent}
      editorItemOptions={editorItemOptions}
    ></InactivatableCrudDataGrid>
  );
};

export default MappingRuleTypeSettings;
